/* ==========================================================
   SARATTI GRB v85 — Consolidated builder patch
   Backup theme only.
   One active patch for:
   - Metal Type text badges
   - Variant guide comparison drawers + Theme Editor guide data
   - Finalise breakdown + ring size gate
   - Ring sizer included in finalise/cart when ticked
   - Cart payload properties matching finalise breakdown
   - Sticky bar sizing / labels / money format
   ========================================================== */
(function () {
  'use strict';

  if (window.__SARATTI_BUILDER_PATCH_V85__) return;
  window.__SARATTI_BUILDER_PATCH_V85__ = true;

  var STATE = { lastBuild: null, fetchPatched: false, grbPatched: false };

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function text(el) { return el ? String(el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function cfg() { return window.GRB_CONFIG || {}; }

  function normalise(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/colour/g, 'color')
      .replace(/lab grown/g, 'lab grown')
      .replace(/laboratory/g, 'lab')
      .replace(/×/g, 'x')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[char];
    });
  }

  function cents(value) {
    if (value === null || value === undefined || value === '') return 0;
    if (typeof value === 'number') return Math.round(value);
    var raw = String(value).replace(/[^0-9.-]/g, '');
    if (!raw) return 0;
    if (/\.\d{1,2}$/.test(raw)) return Math.round(parseFloat(raw) * 100);
    return Math.round(parseFloat(raw));
  }

  function money(value) {
    var amount = (Number(value) || 0) / 100;
    return '$' + amount.toLocaleString('en-US', {
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
  }

  function installCss() {
    if (document.getElementById('saratti-builder-consolidated-v85-style')) return;

    var css = '' +
      '#grb-preview-modal .grb__variant-row--metal-type-v85 .grb__metal-options{display:flex!important;flex-wrap:wrap!important;gap:10px!important;align-items:center!important;}' +
      '#grb-preview-modal .grb__variant-row--metal-type-v85 .grb__metal-option{width:auto!important;min-width:58px!important;height:40px!important;padding:0 16px!important;border-radius:999px!important;background:#fbfaf7!important;border:1px solid rgba(37,39,58,.16)!important;box-shadow:none!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;color:#25273a!important;position:relative!important;overflow:hidden!important;}' +
      '#grb-preview-modal .grb__variant-row--metal-type-v85 .grb__metal-option:before,#grb-preview-modal .grb__variant-row--metal-type-v85 .grb__metal-option:after{display:none!important;content:none!important;}' +
      '#grb-preview-modal .grb__variant-row--metal-type-v85 .grb__metal-swatch{display:none!important;}' +
      '#grb-preview-modal .grb__variant-row--metal-type-v85 .grb__metal-type-badge-text-v85{display:block!important;font-size:12px!important;letter-spacing:.13em!important;text-transform:uppercase!important;font-weight:600!important;line-height:1!important;color:inherit!important;}' +
      '#grb-preview-modal .grb__variant-row--metal-type-v85 .grb__metal-option--active,#grb-preview-modal .grb__variant-row--metal-type-v85 .grb__metal-option[aria-pressed="true"]{background:#25273a!important;border-color:#25273a!important;color:#fff!important;}' +
      '#grb-preview-modal .grb__variant-row--metal-type-v85 .grb__metal-option:disabled{opacity:.34!important;cursor:not-allowed!important;background:#f2f2f1!important;color:#8d919d!important;}' +
      '#grb-preview-modal .grb__variant-row--metal-color-v85 .grb__metal-option{border-radius:50%!important;}' +
      '#grb-preview-modal .grb__config-label .grb__info-btn{margin-left:8px;vertical-align:middle;}' +
      '.grb__variant-guide-list-v85{display:grid;gap:22px;}' +
      '.grb__variant-guide-group-v85{display:grid;gap:12px;}' +
      '.grb__variant-guide-group-title-v85{margin:8px 0 2px;color:#b88a4a;font-size:10px;letter-spacing:.24em;text-transform:uppercase;font-weight:600;}' +
      '.grb__variant-guide-item-v85{display:grid;grid-template-columns:58px minmax(0,1fr);gap:14px;align-items:start;padding:16px 0;border-top:1px solid rgba(37,39,58,.1);}' +
      '.grb__variant-guide-item-v85:first-child{border-top:0;}' +
      '.grb__variant-guide-item-v85--no-image{grid-template-columns:1fr;}' +
      '.grb__variant-guide-img-v85{width:58px;height:58px;background:#f7f5f1;overflow:hidden;border:1px solid rgba(37,39,58,.08);}' +
      '.grb__variant-guide-img-v85 img{width:100%;height:100%;object-fit:cover;display:block;}' +
      '.grb__variant-guide-copy-v85 h4{margin:0 0 7px;color:#25273a;font-size:14px;line-height:1.35;font-weight:600;}' +
      '.grb__variant-guide-copy-v85 .rte,.grb__variant-guide-copy-v85 p{margin:0;color:#666a73;font-size:13px;line-height:1.72;}' +
      '.grb__variant-guide-copy-v85 p+p{margin-top:8px;}' +
      '.grb__variant-guide-copy-v85 ul,.grb__variant-guide-copy-v85 ol{margin:8px 0 0 18px;padding:0;color:#666a73;font-size:13px;line-height:1.72;}' +
      '.grb__tone-grid-v85{display:grid;gap:13px;padding:16px;border:1px solid rgba(37,39,58,.1);}' +
      '.grb__tone-row-v85{display:flex;align-items:center;gap:12px;color:#666a73;font-size:13px;}' +
      '.grb__tone-dot-v85{display:inline-block;width:22px;height:22px;border-radius:999px;border:1px solid rgba(37,39,58,.08);}' +
      '.grb__tone-dot-v85--yellow{background:#dec04b}.grb__tone-dot-v85--white{background:#e5e5e1}.grb__tone-dot-v85--rose{background:#de967a}' +
      '#grb #grb-panel-2 .grb-v85-row span:first-child{white-space:normal!important;overflow:visible!important;text-overflow:clip!important;overflow-wrap:anywhere!important;}' +
      '#grb #grb-panel-2 .grb-v85-row span:last-child{text-align:right!important;white-space:nowrap!important;font-weight:600!important;}' +
      '#grb #grb-panel-2 .grb-v85-row--missing span:last-child{color:#b88a4a!important;}' +
      '#grb .grb-v85-size-missing{cursor:pointer!important;}' +
      '@media screen and (min-width:990px){#grb #grb-stickybar.grb__stickybar{left:50%!important;right:auto!important;width:min(74vw,860px)!important;max-width:860px!important;transform:translate(-50%,18px)!important;grid-template-columns:52px minmax(0,1fr) auto auto!important;}#grb #grb-stickybar.grb__stickybar.grb__stickybar--visible,#grb #grb-stickybar.grb__stickybar.grb-scroll-paused-v71{transform:translate(-50%,0)!important;}}' +
      '@media screen and (max-width:749px){#grb #grb-stickybar.grb__stickybar{left:50%!important;right:auto!important;width:min(42vw,300px)!important;max-width:300px!important;transform:translate(-50%,18px)!important;grid-template-columns:minmax(0,1fr)!important;padding:10px 12px!important;gap:8px!important;}#grb #grb-stickybar.grb__stickybar.grb__stickybar--visible,#grb #grb-stickybar.grb__stickybar.grb-scroll-paused-v71{transform:translate(-50%,0)!important;}#grb #grb-stickybar .grb__sticky-thumb,#grb #grb-stickybar .grb__sticky-copy,#grb #grb-stickybar .grb__sticky-price{display:none!important;}#grb #grb-stickybar .grb__sticky-btn{width:100%!important;min-height:40px!important;padding:0 12px!important;font-size:10px!important;letter-spacing:.12em!important;}}' +
      '@media screen and (min-width:750px) and (max-width:989px){#grb #grb-stickybar.grb__stickybar{left:50%!important;right:auto!important;width:min(58vw,560px)!important;transform:translate(-50%,18px)!important;}#grb #grb-stickybar.grb__stickybar.grb__stickybar--visible,#grb #grb-stickybar.grb__stickybar.grb-scroll-paused-v71{transform:translate(-50%,0)!important;}}';

    var style = document.createElement('style');
    style.id = 'saratti-builder-consolidated-v85-style';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function optionGroup(name) {
    var n = normalise(name);
    if (n.includes('side stone') || n.includes('side diamond') || n.includes('diamond type') || n.includes('stone type')) return 'side_stones';
    if (n.includes('metal color') || n.includes('metal tone') || n.includes('gold color') || n.includes('gold tone') || n === 'color') return 'tone';
    if (n.includes('metal type') || n.includes('metal purity') || n.includes('metal karat') || n.includes('metal carat') || n.includes('material') || n === 'metal') return 'metal';
    if (n.includes('shape')) return 'shape';
    if (n.includes('finish')) return 'finish';
    if (n.includes('size')) return 'size';
    return 'other';
  }

  function displayLabelForOption(name) {
    var group = optionGroup(name);
    if (group === 'side_stones') return 'Side Stones';
    if (group === 'metal') return 'Metal Type';
    if (group === 'tone') return 'Metal Color';
    return String(name || '').trim() || 'Option';
  }

  function optionNameFromRow(row) {
    var label = qs('.grb__config-label', row);
    if (!label) return '';
    var clone = label.cloneNode(true);
    qsa('button, svg', clone).forEach(function (node) { node.remove(); });
    return text(clone);
  }

  function metalBadge(value) {
    var raw = String(value || '').trim();
    var n = normalise(raw);
    if (/\b9\s*k\b/i.test(raw) || n.includes('9k')) return '9K';
    if (/\b10\s*k\b/i.test(raw) || n.includes('10k')) return '10K';
    if (/\b14\s*k\b/i.test(raw) || n.includes('14k')) return '14K';
    if (/\b18\s*k\b/i.test(raw) || n.includes('18k')) return '18K';
    if (/\b22\s*k\b/i.test(raw) || n.includes('22k')) return '22K';
    if (/\b24\s*k\b/i.test(raw) || n.includes('24k')) return '24K';
    if (n.includes('platinum')) return 'PT';
    if (n.includes('925') || n.includes('sterling')) return '925';
    return raw.replace(/\s*gold\s*/ig, '').trim() || raw;
  }

  function patchMetalTypeRows() {
    var modal = document.getElementById('grb-preview-modal');
    if (!modal) return;
    qsa('.grb__variant-row', modal).forEach(function (row) {
      var name = optionNameFromRow(row);
      var group = optionGroup(name);
      row.classList.toggle('grb__variant-row--metal-type-v85', group === 'metal');
      row.classList.toggle('grb__variant-row--metal-color-v85', group === 'tone');
      if (group !== 'metal') return;
      qsa('.grb__metal-option', row).forEach(function (btn) {
        var value = btn.getAttribute('aria-label') || btn.getAttribute('title') || btn.dataset.value || btn.textContent || '';
        var short = metalBadge(value);
        btn.setAttribute('title', value);
        btn.setAttribute('aria-label', value);
        btn.innerHTML = '<span class="grb__metal-type-badge-text-v85">' + escapeHtml(short) + '</span>';
      });
    });
  }

  function settingTitleFromDom() {
    return (text(qs('#grb-final-setting-title')) || text(qs('#grb-sticky-title')) || text(qs('#grb-ts-1')) || '').replace(/\s*·\s*$/g, '').trim();
  }

  function findSetting() {
    var settings = cfg().settings || [];
    if (!settings.length) return null;
    var wanted = normalise(settingTitleFromDom());
    return settings.find(function (setting) {
      var a = normalise(setting.title || '');
      var b = normalise(setting.fullTitle || '');
      return wanted && (a === wanted || b === wanted || a.includes(wanted) || wanted.includes(a) || b.includes(wanted) || wanted.includes(b));
    }) || settings[0];
  }

  function allCurrentOptionText() {
    return [
      text(qs('#grb-final-setting-options')),
      text(qs('#grb-sticky-sub')),
      text(qs('#grb-sum-setting')),
      text(qs('#grb-ts-1')),
      text(qs('#grb-modal-title')),
      text(qs('#grb-modal-price'))
    ].join(' | ');
  }

  function variantScore(variant, hay) {
    var opts = variant && variant.selectedOptions ? variant.selectedOptions : [];
    var score = 0;
    opts.forEach(function (opt) {
      if (hay.indexOf(normalise(opt.value)) > -1) score += 1;
    });
    return score;
  }

  function selectedVariant(setting) {
    if (!setting || !Array.isArray(setting.variants) || !setting.variants.length) return null;
    var hay = normalise(allCurrentOptionText());
    var exact = setting.variants.find(function (variant) {
      var opts = variant.selectedOptions || [];
      return opts.length && opts.every(function (opt) { return hay.indexOf(normalise(opt.value)) > -1; });
    });
    if (exact) return exact;
    return setting.variants.slice().sort(function (a, b) { return variantScore(b, hay) - variantScore(a, hay); })[0] || setting.variants[0];
  }

  function selectedOptions(setting, variant) {
    if (variant && Array.isArray(variant.selectedOptions) && variant.selectedOptions.length) {
      return variant.selectedOptions.filter(function (o) { return o && o.name && o.value; });
    }
    var hay = normalise(allCurrentOptionText());
    var out = [];
    (setting && setting.options || []).forEach(function (option) {
      var val = (option.values || []).find(function (v) { return hay.indexOf(normalise(v)) > -1; });
      if (val) out.push({ name: option.name, value: val });
    });
    return out;
  }

  function cleanSettingTitle(setting) {
    var title = (setting && (setting.title || setting.fullTitle)) || settingTitleFromDom() || 'Selected setting';
    return String(title).replace(/\s*\(([^)]*)\)\s*$/g, '').trim();
  }

  function stoneName() {
    var config = cfg();
    var fromTable = text(qs('#grb-sum-stone-name')).replace(/^Stone\s+—\s*/i, '').replace(/^Center Stone\s+—\s*/i, '');
    return config.productTitle || config.stoneTitle || fromTable || 'Selected center stone';
  }

  function ringSize() {
    var select = qs('#grb-size-select');
    if (select && select.value) return select.value;
    var value = text(qs('#grb-sum-size')).replace(/^Ring size\s+—\s*/i, '');
    if (value && !/not selected|select|ring size/i.test(value)) return value;
    return '';
  }

  function ringSizerIncluded() {
    var checked = qsa('#grb input[type="checkbox"]:checked').find(function (input) {
      var name = normalise(input.name || input.id || input.value || '');
      var label = '';
      if (input.id) {
        var labelEl = document.querySelector('label[for="' + input.id.replace(/"/g, '\\"') + '"]');
        label = text(labelEl);
      }
      if (!label) label = text(input.closest('label')) || text(input.closest('.grb__field, .grb__config-row, .grb__check, .grb__checkbox'));
      var combined = normalise(name + ' ' + label);
      return combined.includes('ring sizer') || combined.includes('ringsizer') || combined.includes('complimentary ring sizer') || combined.includes('request a complimentary ring sizer');
    });
    return !!checked;
  }

  function engraving() {
    var input = qs('#grb-engraving');
    var value = input ? input.value : '';
    if (!value) value = text(qs('#grb-sum-eng'));
    return String(value || '').replace(/^"|"$/g, '').trim();
  }

  function buildBreakdown() {
    var config = cfg();
    var setting = findSetting();
    var variant = selectedVariant(setting);
    var opts = selectedOptions(setting, variant);
    var stonePrice = cents(config.stonePrice);
    var settingPrice = variant ? cents(variant.price) : 0;
    var rows = [];

    rows.push({ key: 'Center Stone', label: 'Center Stone', value: stoneName(), price: money(stonePrice), role: 'stone' });
    rows.push({ key: 'Setting', label: 'Setting', value: cleanSettingTitle(setting), price: money(settingPrice), role: 'setting' });

    var order = { side_stones: 1, metal: 2, tone: 3, shape: 4, finish: 5, other: 9 };
    var seenLabels = {};
    opts.slice().sort(function (a, b) { return (order[optionGroup(a.name)] || 9) - (order[optionGroup(b.name)] || 9); }).forEach(function (opt) {
      var group = optionGroup(opt.name);
      var label = displayLabelForOption(opt.name);
      if (seenLabels[label]) return;
      seenLabels[label] = true;
      rows.push({ key: label, label: label, value: opt.value, price: 'Included', role: group });
    });

    var size = ringSize();
    rows.push({ key: 'Ring Size', label: 'Ring Size', value: size || 'Select ring size', price: '', role: 'size', required: true });
    if (ringSizerIncluded()) {
      rows.push({ key: 'Ring Sizer', label: 'Ring Sizer', value: 'Included', price: '', role: 'ring_sizer' });
    }
    rows.push({ key: 'Engraving', label: 'Engraving', value: engraving() || '—', price: '', role: 'engraving' });

    return { setting: setting, variant: variant, options: opts, rows: rows, size: size, ringSizer: ringSizerIncluded(), total: stonePrice + settingPrice };
  }

  function renderFinalise() {
    var commission = qs('#grb-panel-2 .grb__commission');
    if (!commission) return;
    var data = buildBreakdown();
    STATE.lastBuild = data;
    var html = data.rows.map(function (row) {
      var left = row.label + ' — ' + row.value;
      var right = row.price || '';
      if (row.role === 'size' || row.role === 'engraving' || row.role === 'ring_sizer') { left = row.label; right = row.value; }
      var cls = 'grb__commission-row grb-v85-row grb-v85-row--' + row.role + (row.required && !data.size ? ' grb-v85-row--missing' : '');
      return '<div class="' + cls + '"><span>' + escapeHtml(left) + '</span><span>' + escapeHtml(right) + '</span></div>';
    }).join('') + '<div class="grb__commission-total"><span>Total</span><span id="grb-sum-total">' + money(data.total) + '</span></div>';
    if (commission.dataset.v85Html !== html) { commission.dataset.v85Html = html; commission.innerHTML = html; }
  }

  function updateButtonsAndSticky() {
    var data = STATE.lastBuild || buildBreakdown();
    var hasSize = !!data.size;
    qsa('#grb-sticky-price,#grb-sbar-price,#grb-sum-total').forEach(function (el) { if (el) el.textContent = money(data.total); });
    qsa('#grb-cart-btn,#grb-sticky-btn,#grb-sbar-btn').forEach(function (btn) {
      if (!btn) return;
      if (btn.id === 'grb-cart-btn') btn.textContent = hasSize ? 'Add both to cart — ' + money(data.total) : 'Select ring size to continue';
      else btn.textContent = hasSize ? 'Add both to cart' : 'Select ring size';
      btn.disabled = false;
      btn.classList.toggle('grb-v85-size-missing', !hasSize);
      btn.setAttribute('data-grb-v85-size-gate', hasSize ? 'false' : 'true');
    });
    var title = qs('#grb-sticky-title');
    var sub = qs('#grb-sticky-sub');
    if (title) title.textContent = data.setting ? cleanSettingTitle(data.setting) : stoneName();
    if (sub) {
      var parts = [];
      data.rows.forEach(function (row) {
        if (row.role === 'stone') parts.push('Center stone: ' + row.value);
        if (row.role === 'side_stones') parts.push('Side stones: ' + row.value);
        if (row.role === 'metal') parts.push('Metal type: ' + row.value);
        if (row.role === 'tone') parts.push('Metal color: ' + row.value);
        if (row.role === 'ring_sizer') parts.push('Ring sizer: Included');
      });
      sub.textContent = parts.join(' · ');
    }
  }

  function focusRingSize() {
    var target = qs('#grb-size-select');
    if (!target) return false;
    target.classList.add('grb__field--error');
    target.setAttribute('aria-invalid', 'true');
    var wrap = target.closest('.grb__config-row') || target;
    if (wrap.scrollIntoView) wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.setTimeout(function () { try { target.focus({ preventScroll: true }); } catch (e) { try { target.focus(); } catch (_) {} } }, 260);
    return true;
  }

  function patchFetch() {
    if (STATE.fetchPatched || !window.fetch) return;
    STATE.fetchPatched = true;
    var original = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url.indexOf('/cart/add') > -1 && init && init.body) {
          var data = STATE.lastBuild || buildBreakdown();
          if (!data.size) { focusRingSize(); return Promise.reject(new Error('Ring size required')); }
          var payload = JSON.parse(init.body);
          var props = {};
          data.rows.forEach(function (row) {
            if (row.role === 'engraving' && row.value === '—') return;
            props[row.key] = row.value;
          });
          props.Total = money(data.total);
          if (payload && Array.isArray(payload.items)) {
            payload.items = payload.items.map(function (item) {
              item.properties = Object.assign({}, item.properties || {}, props);
              return item;
            });
            init = Object.assign({}, init, { body: JSON.stringify(payload) });
          }
        }
      } catch (e) {
        if (String(e && e.message || '').includes('Ring size required')) throw e;
      }
      return original.call(this, input, init);
    };
  }

  function readThemeGuides() {
    var guides = [];
    qsa('script[id^="saratti-variant-guides-json-"]').forEach(function (script) {
      try { var parsed = JSON.parse(script.textContent || '[]'); if (Array.isArray(parsed)) guides = guides.concat(parsed); } catch (e) {}
    });
    return guides.filter(function (g) { return g && g.group && g.variantValue && g.heading && g.text; });
  }

  function guideOptionNamesMatch(guide, optionName) {
    var option = normalise(optionName);
    var names = String(guide.optionNames || '').split(',').map(normalise).filter(Boolean);
    if (!names.length) return false;
    return names.some(function (name) { return option === name || option.includes(name) || name.includes(option); });
  }

  function guideValueAvailable(setting, guide) {
    if (!setting || !setting.options) return false;
    var wanted = normalise(guide.variantValue);
    return setting.options.some(function (opt) {
      var names = String(guide.optionNames || '').split(',').map(normalise).filter(Boolean);
      var optionMatch = !names.length || names.some(function (name) { var on = normalise(opt.name); return on === name || on.includes(name) || name.includes(on); });
      return optionMatch && (opt.values || []).map(normalise).indexOf(wanted) > -1;
    });
  }

  function guideGroupsForOption(optionName) {
    var group = optionGroup(optionName);
    if (group === 'metal' || group === 'tone') return ['metal', 'tone'];
    return [group];
  }

  function guideMatches(optionName, setting, guide) {
    var groups = guideGroupsForOption(optionName);
    if (groups.indexOf(guide.group) === -1 && !guideOptionNamesMatch(guide, optionName)) return false;
    return guideValueAvailable(setting, guide);
  }

  function fallbackGuideItems(optionName, setting) {
    var guides = cfg().guides || {};
    var groups = guideGroupsForOption(optionName);
    var items = [];
    var seen = {};
    (setting && setting.options || []).forEach(function (opt) {
      var group = optionGroup(opt.name);
      if (groups.indexOf(group) === -1) return;
      (opt.values || []).forEach(function (value) {
        var key = null;
        if (group === 'metal' || group === 'tone') {
          if (/18\s*k/i.test(value)) key = '18K Gold';
          else if (/14\s*k/i.test(value)) key = '14K Gold';
          else if (/9\s*k/i.test(value)) key = '9K Gold';
          else if (/925|sterling/i.test(value)) key = '925 Sterling Silver';
          else if (/platinum/i.test(value)) key = 'Platinum';
        } else if (group === 'side_stones') {
          if (/natural/i.test(value) && /diamond/i.test(value)) key = 'Natural Diamonds';
          else if (/lab/i.test(value) && /diamond/i.test(value)) key = 'Lab Grown Diamonds';
        }
        if (!key || seen[group + key]) return;
        var html = group === 'side_stones' ? (guides.side || {})[key] : (guides.metal || {})[key];
        if (!html) return;
        seen[group + key] = true;
        items.push({ group: group === 'side_stones' ? 'side_stones' : 'metal', heading: key, text: html, image: null, order: 50 });
      });
    });
    return items;
  }

  function groupLabel(group) {
    if (group === 'metal') return 'Material Guide';
    if (group === 'tone') return 'Tone Guide';
    if (group === 'side_stones') return 'Side Stone Guide';
    if (group === 'shape') return 'Shape Guide';
    if (group === 'finish') return 'Finish Guide';
    if (group === 'size') return 'Size Guide';
    return 'Guide';
  }

  function drawerTitle(optionName) {
    var group = optionGroup(optionName);
    if (group === 'metal' || group === 'tone') return 'SARATTI Material Guide';
    return groupLabel(group);
  }

  function renderGuides(items, optionName) {
    var byGroup = {};
    items.forEach(function (item) { if (!byGroup[item.group]) byGroup[item.group] = []; byGroup[item.group].push(item); });
    var html = '<div class="grb__variant-guide-list-v85">';
    Object.keys(byGroup).forEach(function (group) {
      html += '<div class="grb__variant-guide-group-v85"><div class="grb__variant-guide-group-title-v85">' + escapeHtml(groupLabel(group)) + '</div>';
      byGroup[group].sort(function (a, b) { return Number(a.order || 50) - Number(b.order || 50); }).forEach(function (item) {
        var heading = escapeHtml(item.heading);
        html += '<div class="grb__variant-guide-item-v85' + (item.image ? '' : ' grb__variant-guide-item-v85--no-image') + '">' +
          (item.image ? '<div class="grb__variant-guide-img-v85"><img src="' + item.image + '" alt="' + heading + '"></div>' : '') +
          '<div class="grb__variant-guide-copy-v85"><h4>' + heading + '</h4><div class="rte">' + item.text + '</div></div></div>';
      });
      html += '</div>';
    });
    if (optionGroup(optionName) === 'metal' || optionGroup(optionName) === 'tone') {
      html += '<div class="grb__variant-guide-group-v85"><div class="grb__variant-guide-group-title-v85">Tone Guide</div><div class="grb__tone-grid-v85"><div class="grb__tone-row-v85"><span class="grb__tone-dot-v85 grb__tone-dot-v85--yellow"></span><span>Yellow tone</span></div><div class="grb__tone-row-v85"><span class="grb__tone-dot-v85 grb__tone-dot-v85--white"></span><span>White tone</span></div><div class="grb__tone-row-v85"><span class="grb__tone-dot-v85 grb__tone-dot-v85--rose"></span><span>Rose tone</span></div></div></div>';
    }
    html += '</div>';
    return html;
  }

  function matchingGuideItems(optionName) {
    var setting = findSetting() || (cfg().settings || [])[0];
    var theme = readThemeGuides().filter(function (guide) { return guideMatches(optionName, setting, guide); });
    var fallback = fallbackGuideItems(optionName, setting);
    var existing = {};
    theme.forEach(function (item) { existing[item.group + ':' + normalise(item.variantValue)] = true; });
    fallback.forEach(function (item) {
      if (!existing[item.group + ':' + normalise(item.heading)]) theme.push(item);
    });
    return theme.sort(function (a, b) { return Number(a.order || 50) - Number(b.order || 50); });
  }

  function openGuide(optionName, selectedValue, original) {
    var items = matchingGuideItems(optionName);
    if (!items.length) { if (typeof original === 'function') return original(optionName, selectedValue); return; }
    var title = qs('#grb-guide-title');
    var body = qs('#grb-guide-body');
    var drawer = qs('#grb-guide-drawer');
    if (title) title.textContent = drawerTitle(optionName);
    if (body) body.innerHTML = renderGuides(items, optionName);
    if (drawer) { drawer.classList.add('grb__drawer-bg--open'); drawer.setAttribute('aria-hidden', 'false'); }
  }

  function infoIcon(optionName) {
    return '<button class="grb__info-btn grb__info-btn--v85" type="button" data-grb-v85-guide="true" data-option-name="' + escapeHtml(optionName) + '" aria-label="Open ' + escapeHtml(optionName) + ' guide"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4M12 8h.01"></path></svg></button>';
  }

  function patchInfoIcons() {
    var modal = qs('#grb-preview-modal');
    if (!modal) return;
    qsa('.grb__variant-row', modal).forEach(function (row) {
      var label = qs('.grb__config-label', row);
      if (!label) return;
      var name = optionNameFromRow(row);
      if (!name || !matchingGuideItems(name).length) return;
      if (!label.querySelector('[data-grb-v85-guide="true"], .grb__info-btn')) label.insertAdjacentHTML('beforeend', infoIcon(name));
    });
  }

  function patchGRB() {
    if (STATE.grbPatched || !window.GRB || typeof window.GRB.openVariantGuide !== 'function') return;
    var originalOpenGuide = window.GRB.openVariantGuide;
    window.GRB.openVariantGuide = function (optionName, selectedValue) { return openGuide(optionName, selectedValue, originalOpenGuide); };

    ['openPreview', 'modalPickOption', 'confirmPreview', 'pickSize', 'pickEngraving', 'goTab'].forEach(function (name) {
      if (typeof window.GRB[name] !== 'function') return;
      var original = window.GRB[name];
      window.GRB[name] = function () {
        var result = original.apply(window.GRB, arguments);
        setTimeout(run, 40); setTimeout(run, 180);
        return result;
      };
    });
    STATE.grbPatched = true;
  }

  function bindClicks() {
    if (document.documentElement.dataset.sarattiV85Bound === 'true') return;
    document.documentElement.dataset.sarattiV85Bound = 'true';
    document.addEventListener('click', function (event) {
      var guideBtn = event.target.closest('[data-grb-v85-guide="true"]');
      if (guideBtn) { event.preventDefault(); event.stopPropagation(); openGuide(guideBtn.dataset.optionName || '', '', null); return; }
      var gated = event.target.closest('[data-grb-v85-size-gate="true"]');
      if (gated) { event.preventDefault(); event.stopPropagation(); focusRingSize(); }
    }, true);
  }

  function run() {
    installCss();
    patchGRB();
    patchMetalTypeRows();
    patchInfoIcons();
    renderFinalise();
    updateButtonsAndSticky();
    patchFetch();
  }

  function boot() {
    bindClicks();
    run();
    setTimeout(run, 80); setTimeout(run, 260); setTimeout(run, 700);
    document.addEventListener('click', function () { setTimeout(run, 80); setTimeout(run, 260); }, true);
    document.addEventListener('change', function () { setTimeout(run, 80); setTimeout(run, 260); }, true);
    document.addEventListener('input', function () { setTimeout(run, 80); }, true);
    var root = document.getElementById('grb') || document.body;
    if (root && !root.dataset.sarattiV85Observer) {
      root.dataset.sarattiV85Observer = 'true';
      new MutationObserver(function () { clearTimeout(root._sarattiV85Timer); root._sarattiV85Timer = setTimeout(run, 90); }).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', boot);
})();
